var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityVideoPlayTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5824C0 29.7452 1.28808 30.446 2.26433 29.8143L23.0394 16.3716C23.933 15.7934 23.933 14.486 23.0394 13.9079L2.26433 0.465157C1.28808 -0.166535 0 0.534214 0 1.69701V28.5824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityVideoPlayTriangle);
export default __webpack_public_path__ + "static/media/community_video_play_triangle.37600bcf831ed47ebec8fb7f8b89977f.svg";
export { ForwardRef as ReactComponent };